import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { __API_URL__ } from "../SERVER_URL";
import { showApiErrorToast } from "../utils/helpers";

const fetchVisitAdvancedSurveys = async ({ visitId, stepId }) => {
  const token = localStorage.getItem("token");

  const params = new URLSearchParams();
  if (stepId) params.append("step_id", stepId);

  const URL = `${__API_URL__}/api/survey/visits/${visitId}/advanced-surveys/?${params.toString()}`;

  const res = await axios.get(URL, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return res.data;
};

const useGetVisitAdvancedSurveys = ({ visitId, stepId, enabled = true }) => {
  return useQuery({
    queryKey: ["visit_advanced_surveys", visitId, stepId],
    queryFn: () => fetchVisitAdvancedSurveys({ visitId, stepId }),
    enabled: enabled && Boolean(visitId),
    onError: (error) => {
      showApiErrorToast(error, "Failed to load visit surveys");
    },
  });
};

export default useGetVisitAdvancedSurveys;
